export const setShowToast = 'toast/setShowToast';
export const setShowToastConfirm = 'toast/setShowToastConfirm';
export const setMessageToast = 'toast/setMessageToast';
export const setTimerToast = 'toast/setTimerToast';
export const setIconToast = 'toast/setIconToast';
export const setThemeToast = 'toast/setThemeToast';
export const setCallbackToast = 'toast/setCallbackToast';
